module.exports = __webpack_public_path__ + "static/media/CommitedToHealth&SafetyInfectionControlCertificate.8b572602.png";